import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=4a057208&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=4a057208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a057208",
  null
  
)

export default component.exports